import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Portfolio from "../pages/portfolio/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Services from "../pages/services/page";
import Layout from "../components/feature/Layout";
import ServiceDetailPage from "../pages/service-detail/page";
import ProjectDetailPage from "../pages/project-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "services", element: <Services /> },
      { path: "portfolio", element: <Portfolio /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "residential-development-design-melbourne", element: <ServiceDetailPage /> },
      { path: "custom-home-design-melbourne", element: <ServiceDetailPage /> },
      { path: "commercial-building-design-melbourne", element: <ServiceDetailPage /> },
      { path: "interior-design-melbourne", element: <ServiceDetailPage /> },
      { path: "planning-project-management-melbourne", element: <ServiceDetailPage /> },
      { path: "portfolio/mitcham-townhouse-subdivision", element: <ProjectDetailPage /> },
      { path: "portfolio/ringwood-terrace-townhouses", element: <ProjectDetailPage /> },
      { path: "portfolio/toorak-luxury-residence", element: <ProjectDetailPage /> },
      { path: "portfolio/carlton-cafe-patisserie", element: <ProjectDetailPage /> },
      { path: "portfolio/yering-hotel", element: <ProjectDetailPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;
